import { useTranslation } from "next-i18next";
import Marquee from "@/components/CSR/Marquee";
import { IDonationRate } from "@/props/IDonation";

// 项目详情
const EventDetail = ({
  tradingRate,
  dreamPointRate,
  isMobile,
}: {
  tradingRate: IDonationRate;
  dreamPointRate: IDonationRate;
  isMobile: boolean;
}) => {
  const { t } = useTranslation();
  const images = [
    "/images/csr/event_detail_1.webp",
    "/images/csr/event_detail_2.webp",
    "/images/csr/event_detail_3.webp",
    "/images/csr/event_detail_4.webp",
    "/images/csr/event_detail_5.webp",
    "/images/csr/event_detail_6.webp",
    "/images/csr/event_detail_7.webp",
    "/images/csr/event_detail_8.webp",
    "/images/csr/event_detail_9.webp",
    "/images/csr/event_detail_10.webp",
    "/images/csr/event_detail_11.webp",
    "/images/csr/event_detail_12.webp",
    "/images/csr/event_detail_13.webp"
  ];
  return (
    <div className={`w-full text-stone-800 ${isMobile ? "mt-[48px]" : "mt-[80px]"}`}>
      <div
        className={`m-auto  max-w-[1200px] text-center
          ${isMobile ? "mb-[48px]" : "mb-[70px]"}`}
      >
        <h3
          className={`font-semibold
            ${isMobile ? "mb-6 h-[48px] text-2xl" : "mb-10 h-[60px] text-5xl"}`}
        >
          {t("csr.event")}
          <span className="ml-1 inline-block bg-yellow-600 p-2">{t("csr.event_detail")}</span>
        </h3>
        <p className={`${isMobile ? "px-4 text-sm" : "text-2xl"}`}>{t("csr.detail_desc_1")}</p>
        <p className={`mb-4 text-left ${isMobile ? "px-4 text-sm" : "text-2xl"}`}>{t("csr.detail_desc_2")}</p>
      </div>
      <Marquee items={images} speed={100} hasShadow={false} isImage={true} isMobile={isMobile} />
    </div>
  );
};
export default EventDetail;
